// Generated by purs version 0.15.15
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var monadLogAff = {
    log: /* #__PURE__ */ Effect_Class_Console.log(Effect_Aff.monadEffectAff)
};
var log = function (dict) {
    return dict.log;
};
var monadLogReaderT = function (dictMonad) {
    var lift1 = lift(dictMonad);
    return function (dictMonadLog) {
        return {
            log: (function () {
                var $10 = log(dictMonadLog);
                return function ($11) {
                    return lift1($10($11));
                };
            })()
        };
    };
};
export {
    log,
    monadLogAff,
    monadLogReaderT
};
